import { ResponseV2 } from "@/types/responseV2";
import { apiClientV2 } from "./apiClientV2";
import { RoleV2 } from "@/types";

const getRolesV2 = () =>
  apiClientV2.get<ResponseV2<RoleV2[]>, ResponseV2<RoleV2[]>>("/roles");
const getRoleV2 = (id: number) =>
  apiClientV2.get<ResponseV2<RoleV2>, ResponseV2<RoleV2>>(`/roles/${id}`);

const postRoleV2 = (payload: Partial<RoleV2>) =>
  apiClientV2.post<ResponseV2<RoleV2>, ResponseV2<RoleV2>>("/roles", payload);

const patchRoleV2 = (id: number, payload: Partial<RoleV2>) =>
  apiClientV2.post<ResponseV2<RoleV2>, ResponseV2<RoleV2>>(
    `/roles/${id}`,
    payload
  );

export const roles = {
  get: getRoleV2,
  getAll: getRolesV2,
  post: postRoleV2,
  patch: patchRoleV2,
};
